<script>
export default {
    props: ['model', 'prop', 'height','toolbar','noToolbar', 'selectedHeaderStyle', 'alignment', 'inCms'],  
    data() {
        return {
           editorOptions: {
            modules: {
                toolbar: false, 
            },
            theme: 'snow'
            }
        }
    },
    methods: {
        getToolbarStyle: function() {  
            return 'essential';
        }
    },
    computed:
    {
        fontFamily() { return this.selectedHeaderStyle ? this.selectedHeaderStyle.font_family : '' },
        fontColor() { return this.selectedHeaderStyle ? this.selectedHeaderStyle.color : '' },
        textTransform() { if(this.selectedHeaderStyle) { return this.selectedHeaderStyle.is_lower_case ? 'none' : 'uppercase' } return '' },

    }
    
}
</script>
<template>  
<div :style="{ 'height': height == undefined ? '200px' : height, '--editor-font': fontFamily, '--editor-color': fontColor,'--editor-alignment': alignment, '--editor-text-transform': textTransform }"  class="editor-wrap">
    <QuillEditor v-if=noToolbar :contentType="'html'" :options="editorOptions" v-model:content="model[prop]"></QuillEditor>
    <QuillEditor v-else :contentType="'html'" :toolbar="toolbar != undefined ? toolbar : 'essential'" v-model:content="model[prop]"></QuillEditor>
</div>
</template>
<style scoped>  

/* Rubrikerna */
.editor-wrap :deep(.ql-editor h1),
.editor-wrap :deep(.ql-editor h2),
.editor-wrap :deep(.ql-editor h3),
.editor-wrap :deep(.ql-editor h4),
.editor-wrap :deep(.ql-editor h5),
.editor-wrap :deep(.ql-editor h6) {
   font-family: var(--editor-font), serif;
    text-transform: var(--editor-text-transform);
   color: var(--editor-color);
}

.editor-wrap :deep(.ql-editor) {
    background-color: rgb(172 171 173 / 10%) !important;
    border: 1px dashed #a5a5a5 !important;
    text-align:  var(--editor-alignment) !important;
}

.editor-wrap :deep(.ql-container) {
    border:0 !important;
}
</style>